<div class="main-content">
    <div class="card">
        <p-toolbar styleClass="p-mb-4">
            <ng-template pTemplate="left"></ng-template>
            <ng-template pTemplate="right">
                <button pButton pRipple label="{{ 'TAGS.ADD_NEW' | translate }}" icon="pi pi-plus"
                        class="p-button-success mr-2 njoyButton" (click)="addNew()"></button>
            </ng-template>
        </p-toolbar>
        <p-table #dt [value]="tags"
                    [rows]="10"
                    [first]="first"
                    [totalRecords]="totalRecords"
                    (onPage)="onLazyLoad($event)"
                    [paginator]="true"
                    [lazy]="true"
                    [rowHover]="true"
                    [showCurrentPageReport]="true" 
                    [rowsPerPageOptions]="[10,25,50]">
            <ng-template pTemplate="header">
                <tr>
                    <th>{{ 'OFFERS.LABEL' | translate }}</th>
                    <th>{{ 'TAGS.TEXTE_COLOR_LABEL' | translate }}</th>
                    <th>{{ 'TAGS.BACKGROUND_COLOR_LABEL' | translate }}</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-tag>
                <tr (dblclick)="openUpdateModal(tag)">
                    <td>{{tag?.label}}</td>
                    <td>
                        <div class="td-container" [(style.backgroundColor)]="tag.textColor"></div>
                    </td>
                    <td>
                        <div class="td-container" [(style.backgroundColor)]="tag.backgroundColor"></div>
                    </td>
                    <td>
                        <button pButton pRipple icon="pi pi-times" class="p-button-rounded njoyButton"
                                (click)="confirmDeleteTag(tag)"></button>
                    </td>

                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<p-dialog *ngIf="addNewTagDialog" [(visible)]="addNewTagDialog" [style]="{width: '735px'}"
          [header]="modalTitle" [modal]="true"
          styleClass="p-fluid">
    <div class="container-fluid">
        <form [formGroup]="tagForm">
            <div class="row">
                <div class="col-md-2 mt-4">
                    <mat-label>{{ 'OFFERS.LABEL' | translate }} *</mat-label>
                </div>
                <div class="col-md-10">
                    <mat-form-field class="example-full-width">
                        <input matInput formControlName="label"
                               [errorStateMatcher]="matcher" type="text">
                        <mat-error *ngIf="getControl?.label?.errors?.required">
                            {{ 'CATEGORY.LABEL_REQUIRED_ERROR_LABEL' | translate }}
                            <strong>{{ 'COMMON.REQUIRED_FEMALE' | translate }}</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-md-3">
                    <mat-label>{{ 'TAGS.TEXTE_COLOR_LABEL' | translate }} *</mat-label>
                </div>
                <div class="col-md-3">
                    <p-colorPicker [appendTo]="'body'" formControlName="textColor" #textColor></p-colorPicker>
                    <input type="text" class="k-textbox row ml-0 tag-w-100" (change)="onColorChanged(textColor)" [(ngModel)]="textColor.inputBgColor"
                           [ngModelOptions]="{standalone: true}" />
                </div>
                <div class="col-md-4">
                    <mat-label>{{ 'TAGS.BACKGROUND_COLOR_LABEL' | translate }} *</mat-label>
                </div>
                <div class="col-md-2">
                    <p-colorPicker [appendTo]="'body'" formControlName="backgroundColor" #backgroundColor></p-colorPicker>
                    <input type="text" class="k-textbox row ml-0 tag-w-100" (change)="onColorChanged(backgroundColor)" [(ngModel)]="backgroundColor.inputBgColor"
                           [ngModelOptions]="{standalone: true}" />
                </div>
            </div>
        </form>
    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple label="{{ 'BUTTONS.SAVE' | translate }}" icon="pi pi-check" class="p-button-text"
                (click)="addOrUpdateTag()"></button>
    </ng-template>
</p-dialog>
<p-toast></p-toast>
<p-confirmDialog #cd header="Confirmation"
                 icon="pi pi-exclamation-triangle"
                 acceptLabel="{{ 'BUTTONS.YES' | translate }}"
                 rejectLabel="{{ 'BUTTONS.NO' | translate }}"
>
    <ng-template pTemplate="footer">
        <button type="button" pButton icon="pi pi-check" label="Yes" (click)="cd.accept()"></button>
        <button type="button" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
    </ng-template>
</p-confirmDialog>
